export const permission = {
  root: [
    'search',
    'mapSearch',
    'sea',
    'createMySea',
    'createIncSea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'user',
    'plan',
    'square'
  ],
  admin: ['account', 'user'],
  agent: ['account', 'user'],
  customer: [
    'search',
    'mapSearch',
    'sea',
    'createMySea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'user'
  ],
  bigcustomer: [
    'search',
    'mapSearch',

    'sea',
    'createMySea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'user',
    'callRecords',
    'square'
  ],
  manager: [
    'search',
    'mapSearch',

    'sea',
    'createMySea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'user',
    'square'
  ],
  person: [
    'search',
    'mapSearch',

    'sea',
    'createMySea',
    'createIncSea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'callRecords',
    'speechRobot',
    'task',
    'square'
  ],
  mainaccount: [
    'search',
    'mapSearch',
    'sea',
    'createIncSea',
    'createMySea',
    'pool',
    'recycle',
    'album',
    'createAlbumSea',
    'account',
    'user',
    'callRecords',
    'speechRobot',
    'task',
    'square'
  ],
  subaccount: [
    'search',
    'mapSearch',

    'sea',
    'createMySea',
    'pool',
    'recycle',
    'album',
    'account',
    'callRecords',
    'task',
    'square'
  ]
};

export const userColumn = {
  root: [
    'userType',
    'username',
    'email',
    'mobile',
    'company',
    'agentName',
    'customer',
    'status',
    'createTime',
    'expiryTime',
    'connectStatus',
    'creator_username',
    'bms_site'
  ],
  admin: [
    'username',
    'email',
    'mobile',
    'company',
    'agentName',
    'status',
    'createTime',
    'expiryTime',
    'creator_username',
    'bms_site'
  ],
  agent: [
    'userType',
    'username',
    'email',
    'mobile',
    'company',
    'customer',
    'bigcustomer',
    'mealType',
    'status',
    'createTime',
    'expiryTime',
    'connectStatus',
    'creator_username'
  ],
  customer: [
    'userType',
    'username',
    'email',
    'mobile',
    'company',
    'mealType',
    'status',
    'createTime',
    'expiryTime',
    'connectStatus',
    'creator_username'
  ],
  bigcustomer: [
    'userType',
    'username',
    'email',
    'mobile',
    'manager',
    'mainaccount',
    'mealType',
    'status',
    'createTime',
    'lastlogin',
    'weekly',
    'connectStatus',
    'creator_username'
  ],
  manager: [
    'userType',
    'username',
    'email',
    'mobile',
    'mainaccount',
    'mealType',
    'status',
    'createTime',
    'lastlogin',
    'weekly',
    'connectStatus',
    'creator_username'
  ],
  mainaccount: [
    'username',
    'email',
    'mobile',
    'status',
    'createTime',
    'lastlogin',
    'weekly',
    'connectStatus',
    'creator_username'
  ]
};

export const userFilter = {
  root: ['userType', 'agentName', 'status', 'connectStatus'],
  admin: ['agentName', 'status', 'connectStatus'],
  agent: ['userType', 'status', 'mealType', 'connectStatus'],
  customer: ['userType', 'status', 'mealType', 'connectStatus'],
  bigcustomer: ['userType', 'status', 'mealType', 'connectStatus'],
  manager: ['userType', 'status', 'mealType', 'connectStatus'],
  mainaccount: ['status', 'connectStatus']
};

const editPermission = {
  root_admin: ['userType', 'username', 'mobile', 'email'],
  root_agent: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'agent_name',
    'pay_type',
    'expiry_date',
    'agent_total_amount',
    'logo',
    'domain',
    'logout_domain',
    'protocol_domain',
    'editAddedService'
  ],
  root_customer: [
    'userType',
    'username',
    'mobile',
    'email',
    'agent_name',
    'total_amount'
  ],
  root_bigcustomer: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'expiry_date',
    'meals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'addDailyNum'
  ],
  root_manager: ['userType', 'username', 'mobile', 'email'],
  root_mainaccount: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'manager',
    'expiry_date',
    'mainmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  root_person: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'manager',
    'expiry_date',
    'personmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  root_subaccount: ['userType', 'username', 'mobile', 'email'],
  admin_agent: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'agent_name',
    'pay_type',
    'agent_total_amount',
    'logo',
    'domain',
    'logout_domain',
    'protocol_domain'
  ],
  agent_customer: [
    'userType',
    'username',
    'mobile',
    'email',
    'agent_name',
    'total_amount'
  ],
  agent_bigcustomer: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'expiry_date',
    'meals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'addDailyNum'
  ],
  agent_mainaccount: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'manager',
    'expiry_date',
    'mainmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  agent_person: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'customer',
    'manager',
    'expiry_date',
    'personmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  customer_bigcustomer: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'expiry_date',
    'meals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'addDailyNum'
  ],
  customer_mainaccount: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'expiry_date',
    'mainmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  customer_person: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'expiry_date',
    'personmeals',
    'editAddedService',
    'extraSubCount',
    'extraExpiry',
    'editMask',
    'addDailyNum',
    'editPlugin'
  ],
  bigcustomer_mainaccount: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'manager',
    'mainmeals',
    'editMask',
    'editAddedService',
    'editPlugin'
  ],
  bigcustomer_person: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'manager',
    'personmeals',
    'editMask',
    'editAddedService',
    'editPlugin'
  ],
  bigcustomer_manager: ['userType', 'username', 'mobile', 'email'],
  bigcustomer_subaccount: ['userType', 'username', 'mobile', 'email'],
  manager_mainaccount: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'mainmeals',
    'editMask',
    'editAddedService',
    'editPlugin'
  ],
  manager_person: [
    'userType',
    'username',
    'mobile',
    'email',
    'showcompany',
    'personmeals',
    'editMask',
    'editAddedService',
    'editPlugin'
  ],
  manager_subaccount: ['userType', 'username', 'mobile', 'email'],
  mainaccount_subaccount: ['userType', 'username', 'mobile', 'email']
};
const editField = {
  root_admin: ['_id', 'username'],
  root_agent: [
    '_id',
    'username',
    'agent_name',
    'expiry_date',
    'agent_total_amount',
    'logo',
    'domain',
    'logout_domain',
    'protocol_domain',
    'company'
  ],
  root_customer: ['_id', 'username', 'total_amount'],
  root_bigcustomer: [
    '_id',
    'username',
    'customer',
    'expiry_date',
    'meals',
    'company'
  ],
  root_manager: ['_id', 'username'],
  root_mainaccount: ['_id', 'username', 'expiry_date', 'meals', 'company'],
  root_person: ['_id', 'username', 'expiry_date', 'meals', 'company'],
  root_subaccount: ['_id', 'username'],
  admin_agent: [
    '_id',
    'username',
    'agent_name',
    'agent_total_amount',
    'logo',
    'domain',
    'logout_domain',
    'protocol_domain'
  ],
  agent_customer: ['_id', 'username', 'total_amount'],
  agent_bigcustomer: ['_id', 'username', 'expiry_date'],
  agent_mainaccount: ['_id', 'username', 'expiry_date'],
  customer_bigcustomer: ['_id', 'username'],
  customer_person: ['_id', 'username'],
  customer_mainaccount: ['_id', 'username'],
  bigcustomer_mainaccount: ['_id', 'username', 'manager'],
  bigcustomer_person: ['_id', 'username', 'manager'],
  bigcustomer_manager: ['_id', 'username'],
  bigcustomer_subaccount: ['_id', 'username'],
  manager_person: ['_id', 'username'],
  manager_mainaccount: ['_id', 'username'],
  manager_subaccount: ['_id', 'username'],
  mainaccount_subaccount: ['_id', 'username']
};

export const filterUserTypeOption = {
  root: [
    {
      label: 'Admin',
      value: 'admin'
    },
    {
      label: '分销账户',
      value: 'agent'
    },
    {
      label: '销售客服',
      value: 'customer'
    },
    {
      label: '大客户',
      value: 'bigcustomer'
    },
    {
      label: '管理员',
      value: 'manager'
    },
    {
      label: '个人账户',
      value: 'personaccount'
    },
    {
      label: '主账户',
      value: 'mainaccount'
    },
    {
      label: '子账户',
      value: 'subaccount'
    }
  ],
  admin: [],
  agent: [
    {
      label: '销售客服',
      value: 'customer'
    },
    {
      label: '大客户',
      value: 'bigcustomer'
    },
    {
      label: '个人账户',
      value: 'personaccount'
    },
    {
      label: '主账户',
      value: 'mainaccount'
    }
  ],
  customer: [
    {
      label: '大客户',
      value: 'bigcustomer'
    },
    {
      label: '个人账户',
      value: 'personaccount'
    },
    {
      label: '主账户',
      value: 'mainaccount'
    }
  ],
  bigcustomer: [
    {
      label: '管理员',
      value: 'manager'
    },
    {
      label: '个人账户',
      value: 'personaccount'
    },
    {
      label: '主账户',
      value: 'mainaccount'
    },
    {
      label: '子账户',
      value: 'subaccount'
    }
  ],
  manager: [
    {
      label: '个人账户',
      value: 'personaccount'
    },
    {
      label: '主账户',
      value: 'mainaccount'
    },
    {
      label: '子账户',
      value: 'subaccount'
    }
  ],
  mainaccount: []
};
const operation = {
  root_admin_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy',
    'statics'
  ],
  root_admin_inactive: ['edit', 'link', 'active', 'destroy', 'createLink'],
  root_agent_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'meal',
    'destroy',
    'statics',
    'ak'
  ],
  root_agent_inactive: [
    'edit',
    'link',
    'active',
    'meal',
    'destroy',
    'createLink'
  ],
  root_customer_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy',
    'statics'
  ],
  root_customer_inactive: ['edit', 'link', 'active', 'destroy', 'createLink'],
  root_bigcustomer_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy',
    'ak'
  ],
  root_bigcustomer_inactive: [
    'edit',
    'link',
    'active',
    'destroy',
    'createLink'
  ],
  root_manager_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  root_manager_inactive: ['edit', 'link', 'active', 'destroy', 'createLink'],
  root_person_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  root_person_inactive: ['edit', 'link', 'active', 'destroy', 'createLink'],
  root_mainaccount_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  root_mainaccount_inactive: [
    'edit',
    'link',
    'active',
    'destroy',
    'createLink'
  ],
  root_subaccount_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  root_subaccount_inactive: ['edit', 'link', 'active', 'destroy', 'createLink'],
  admin_agent_active: ['edit', 'toggle', 'reset', 'statics', 'ak', 'meal'],
  admin_agent_inactive: ['edit', 'destroy', 'link', 'meal'],
  agent_customer_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy',
    'statics'
  ],
  agent_customer_inactive: ['edit', 'destroy', 'link'],
  agent_bigcustomer_active: [
    'edit',
    'toggle',
    'reset',
    'updateMeal',
    'replace'
  ],
  agent_bigcustomer_inactive: ['edit', 'destroy', 'updateMeal', 'link'],
  agent_person_active: ['edit', 'toggle', 'reset', 'updateMeal', 'replace'],
  agent_person_inactive: ['edit', 'destroy', 'updateMeal', 'link'],
  agent_mainaccount_active: [
    'edit',
    'toggle',
    'reset',
    'updateMeal',
    'replace'
  ],
  agent_mainaccount_inactive: ['edit', 'destroy', 'updateMeal', 'link'],
  customer_bigcustomer_active: ['edit', 'reset', 'replace'],
  customer_bigcustomer_inactive: ['edit', 'destroy', 'link'],
  customer_person_active: ['edit', 'reset', 'replace'],
  customer_person_inactive: ['edit', 'destroy', 'link'],
  customer_mainaccount_active: ['edit', 'reset', 'replace'],
  customer_mainaccount_inactive: ['edit', 'destroy', 'link'],
  bigcustomer_manager_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  bigcustomer_manager_inactive: ['edit', 'destroy', 'link'],
  bigcustomer_person_active: ['edit', 'replace', 'toggle', 'reset', 'destroy'],
  bigcustomer_person_inactive: ['edit', 'destroy', 'link'],
  bigcustomer_mainaccount_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy'
  ],
  bigcustomer_mainaccount_inactive: ['edit', 'destroy', 'link'],
  bigcustomer_subaccount_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy'
  ],
  bigcustomer_subaccount_inactive: ['edit', 'destroy', 'link'],
  manager_person_active: ['edit', 'toggle', 'reset'],
  manager_person_inactive: ['edit', 'destroy', 'link'],
  manager_mainaccount_active: ['edit', 'toggle', 'reset'],
  manager_mainaccount_inactive: ['edit', 'destroy', 'link'],
  manager_subaccount_active: ['edit', 'toggle', 'reset'],
  manager_subaccount_inactive: ['edit', 'destroy', 'link'],
  mainaccount_subaccount_active: [
    'edit',
    'replace',
    'toggle',
    'reset',
    'destroy'
  ],
  mainaccount_subaccount_inactive: ['edit', 'destroy', 'link']
};

export const calculateOperations = function(parent, child, status = 'active') {
  const key = parent + '_' + child + '_' + status;
  /*console.log(key);*/
  return operation[key];
};

export const calculateEditPermission = function(parent, child) {
  const key = parent + '_' + child;
  return editPermission[key];
};
export const calculateEditField = function(parent, child) {
  const key = parent + '_' + child;
  return editField[key];
};



// WEBPACK FOOTER //
// ./src/common/permission.js